import type {BookingStatusLink} from '../../api-types/bovio/response/booking_status'
import type {
  PaymentMethod,
  PaymentMethodsSettings,
  PaymentMethodType
} from '../../api-types/bovio/response/payment_methods_settings'
import type {LinkType} from '../../booking/types/Link'

/**
 * Different types of viable query parameter keys to request payment-methods-settings
 */
export enum PaymentSettingsIdType {
  Regular = 'offerToken',
  Bundle = 'bundleId',
  Booking = 'bookingId'
}
/**
 * Parameters for making a payment-methods-settings API request.
 */
export type PaymentSettingsRequest = {
  url: string
  profileKey: string
  clientUserAgent: string
  httpRequestId?: string
}

/**
 * Parameters for making a POST payment-sessions API request.
 */
export type CreatePaymentSessionRequest = {
  link: LinkType | BookingStatusLink
  profileKey: string
  clientUserAgent: string
  httpRequestId?: string
}

export enum PaymentMethodIntegration {
  Payrails = 'payrails'
}

/**
 * Each payment method names the integration that collects it. Not in the BoVio
 * schema yet, so it extends the generated type.
 * TODO: Move `integration` to `api-types/bovio` once BoVio ships the schema.
 */
export type PaymentSettings = Omit<PaymentMethodsSettings, 'paymentMethods'> & {
  paymentMethods: (PaymentMethod & {integration?: string})[]
}

/**
 * Session returned by POST payment-sessions. It initializes the provider SDK for
 * the payment methods it lists. BoVio returns `{}` when no session could be created.
 * TODO: Replace with the `api-types/bovio` type once BoVio ships the schema.
 */
export type PaymentSession = {
  id: string
  provider: PaymentMethodIntegration
  paymentMethods: PaymentMethodType[]
  expiresAt: string
  /** Passed as is to the provider SDK initialization */
  sdkConfig: {
    version: string
    data: string
  }
}

export type PaymentSessionResponse = PaymentSession | Record<string, never>

/**
 * input params for payment settings selectors
 */
export type PaymentSettingsParamsInput = {
  id: string
  idType: PaymentSettingsIdType
}
